<template>
  <div class="cell">
    <div v-if="item" :style="style" :class="item.type" @change="handleChange">
      <div class="top">
        <div>
          <data-icon :type="item.type"></data-icon>
          <preview-link :item="item">
            {{ item.name }}
          </preview-link>
        </div>
      </div>
      <div class="buttons">
        <el-checkbox-button :value="item.is_first">
          <i class="fa fa-thumb-tack" aria-hidden="true"></i>
        </el-checkbox-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cell {
  overflow: hidden;
  width: 100%;
  position: relative;
  display: flex;
  font-size: 0.7em;
}

.cell > div {
  flex: 1 1 auto;
  margin: 2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  border: 1px solid #EFF2F7;
  width: 100%;

  &.workfolder {
    background-color: #dcdcdc;
  }

  &.track, &.videotrack, &.track, &.route {
    background-color: navy;
  }
}

.top {
  flex: 1 1 auto;

  & > div {
    background: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;

    a {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.buttons {
  flex: 0 0 auto;
  padding: 2px;
  display: flex;
  flex-direction: row-reverse;

  /deep/ .el-checkbox-button:last-child .el-checkbox-button__inner {
    border-radius: 4px;
    padding: 7px 15px;
    font-size: 12px;
  }
}
</style>

<script>
import { CDN_URL, getPreviewUrl } from '@/utils/cdn'
import DataIcon from './DataIcon'
import PreviewLink from './PreviewLink'

export default {
  props: ['item'],
  components: {
    DataIcon,
    PreviewLink
  },
  computed: {
    url () {
      return getPreviewUrl(CDN_URL, this.item.type, this.item.data_name)
    },
    style () {
      return {
        'background-image': this.item.type !== 'workfolder' ? `url(${this.url})` : 'none'
      }
    }
  },
  methods: {
    handleChange () {
      this.$emit('on-pintop', { ...this.item, is_first: !this.item.is_first })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/suggestions/SuggestedCell.vue